/**
 * A label for the version history, not a fingerprint.
 *
 * The server records it so "edited on another device" can name the other
 * device. Deliberately coarse: the platform token and nothing else, because a
 * durable per-browser identifier here would be tracking rather than history.
 *
 * In `src/hud` rather than beside the editor's autosave because both the editor
 * and the Designs list upload versions now, and the second one importing from
 * `src/app` would invert the layering for one string.
 */
export function deviceLabel(): string {
  const ua = typeof navigator === "undefined" ? "" : navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) return "iPad or iPhone";
  if (/Android/.test(ua)) return "Android";
  if (/Mac OS X/.test(ua)) return "Mac";
  if (/Windows/.test(ua)) return "Windows";
  return "This browser";
}
